import type { ComponentProps } from 'react';

import { PRODUCT_TYPE_E_COUPON } from '~/domains/e-coupon/constants';
import ECouponProductCard from '~/domains/products/components/ECouponProductCard';
import { InfiniteGridDisplay } from '~/domains/products/components/GridListDisplay';
import type InfiniteProductGridDisplay from '~/domains/products/components/InfiniteProductGridDisplay';
import ProductCard from '~/domains/products/components/ProductCard';
import ProductDisplaySortType from '~/domains/products/components/ProductDisplaySortType';
import ProductDisplayHeaderTotalCount from '~/domains/products/components/ProductDisplayTotalCount';

type Props = {
  totalCount?: number;
  sortType?: 'SCORE' | 'DISPLAY_RANK' | 'LOW_PRICE' | 'LATEST_PRODUCTS';
} & ComponentProps<typeof InfiniteProductGridDisplay>;

export function SearchResultProductList({
  totalCount,
  data,
  sortType,
  fetchNextPage,
  hasNextPage,
}: Props) {
  return (
    <article className="pb-80">
      <div className="flex h-[46px] items-center justify-between px-20">
        {!!totalCount && (
          <ProductDisplayHeaderTotalCount totalCount={totalCount} />
        )}
        {sortType && <ProductDisplaySortType sortType={sortType} />}
      </div>

      <div className="px-20">
        <InfiniteGridDisplay
          data={data}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          render={(item, index) => {
            if (item.productType === PRODUCT_TYPE_E_COUPON) {
              return (
                <ECouponProductCard
                  key={item.offerId}
                  {...item}
                  reverseCouponDiscountedPrice
                  eventOption={{
                    rank: index + 1,
                  }}
                  isAd={item.isAdvertisement}
                />
              );
            }

            return (
              <ProductCard
                key={item.offerId}
                {...item}
                plusMembershipFullBadge
                reverseCouponDiscountedPrice
                eventOption={{
                  rank: index + 1,
                }}
                isAd={item.isAdvertisement}
              />
            );
          }}
        />
      </div>
    </article>
  );
}
